import config from 'config';
import tmpl from './map.phtml';
import View from 'lib/View';
import PondList from 'model/PondList';
import * as repo from 'db/repositories';

export default View.extend({
	el: '#map',

	template: tmpl,

	// Objets Leaflat
	map: null, // L.map => la carte
	marker: null, // L.marker => notre position géographique
	layer: {}, // L.tileLayer => les différents types de carte
	markersByUuid: {}, // uuid → L.circleMarker (mares du viewport)

	// Icônes du marqueur de notre position
	icons: {
		valid: L.divIcon( {
			iconSize: [ 30, 30 ],
			iconAnchor: [ 15, 15 ],
			className: 'locate-icon locate-icon-valid pulse',
			html: '<div><i class="fas fa-plus"></i></div>'
		}),
		error: L.divIcon({
			iconSize: [ 30, 30 ],
			iconAnchor: [ 15, 15 ],
			className: 'locate-icon locate-icon-error pulse',
			html: '<div><i class="fas fa-question"></i></div>'
		})
	},


	events: {
		'click .js-map-type': function( evt ) { evt.preventDefault(); this.setMapType( $(evt.target).data('type') ); },
		'click .js-reset-position': function( evt )
		{
			evt.preventDefault();

			if( this.geolocation.isLocated() )
			{
				this.setMapLatLng( this.geolocation.getLatLng() );
				app.set( 'moved', false );
			}

			this.trigger('reset');
		},
	},


	/*
	 * Cette vue génère les événements suivants :
	 * - drag => Le marker est en cours de déplacement
	 * - click => La personne a cliqué sur la carte
	 * - reset => La personne a cliqué sur l'icône "reset" à côté des positions affichées
	 *
	 * Méthodes publiques :
	 * - setMapType( evt|type ) => Choisi le layer (soit evt avet $(evt.target).data('type') ou type =
	 * - setMapLatLng( latlng, zoom ) => Déplace la carte à une position (zoom en option)
	 * - setMarkerLatLng( latlng ) => Déplace le marker à une position (génère l'événement drag)
	 * - setPositionText( latlng ) => Modifie les coordonnées affichées
	 *
	 * Méthodes "privées" :
	 * - setMarkerList() => Diff des marqueurs (ajoute / retire / met à jour)
	 * - unsetMarkerList() => retire tous les marqueurs mares
	 * - setConfig() => Sauvegarde la configuration actuelle de la carte (bounds et layer)
	 * - getConfig() => Récupère la configuration de la carte
	 */



	initialize: function()
	{
		this.settings = app.getStore('settings');

		// Démarrage de la géolocalisation
		this.geolocation = app.getStore('geolocation');
		this.geolocation.startWatching();

		// Définition des fonds de carte
		this.layer['plan'] = L.tileLayer('https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',  {
		    maxZoom: config.map.maxZoom,
		    attribution: '© OpenStreetMap contributors'
		});
		this.layer['ign'] = L.tileLayer(
		    'https://data.geopf.fr/wmts?' +
		    'REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0' +
		    '&TILEMATRIXSET=PM' +
		    '&LAYER={ignLayer}&STYLE={style}&FORMAT={format}' +
		    '&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}',
		    {
		        ignLayer: 'ORTHOIMAGERY.ORTHOPHOTOS',
		        style: 'normal',
		        format: 'image/jpeg',
		        attribution: '© IGN / Géoplateforme',
		        maxNativeZoom: config.map.maxNativeZoom,
		        maxZoom: config.map.maxZoom
		    }
		);

		// Le marqueur de ma position
		this.marker = L.marker( this.getLatLng(), { interactive: false, zIndexOffset: 0 });
		this.setMarkerIcon();
		this.listenTo( this, 'render', function()
		{
			this.marker.addTo( this.map );
		});


		this.listenTo( this.geolocation, 'change:located', this.setMarkerIcon );
		this.listenTo( this.geolocation, 'latlng', this.setMarkerLatLng  );
		this.listenTo( this.geolocation, 'change:accuracy error latlng', this.setAccuracyAlert );

		// Collection page-scoped (Dexie après cache bbox opportuniste)
		this.collection = new PondList();
		this.listenTo( app, 'synched', this.loadViewportPonds );
		this.listenTo( app, 'realtime:entity', this.loadViewportPonds );
	},



	unload: function()
	{
		this.geolocation.stopWatching();

		this.unsetMarkerList();

		if( this.marker )
		{
			this.marker.off();
			this.marker.remove();
			delete this.marker;
		}

		for( var l in this.layer )
		{
			this.layer[l].off();
			this.layer[l].remove();
			delete this.layer[l];
		}

		if( this.map )
		{
			this.map.off();
			this.map.remove();
			delete this.map;
		}

		this.doUnload();
	},


	// Quelque part entre notre position et la position enregistrée… Enfin bref, le centre de la carte souhaité
	getLatLng: function()
	{
		return ( app.not('moved') && this.geolocation.isLocated() ) ? this.geolocation.getLatLng() : this.settings.getLatLng();
	},


	// Change l'icône du marqueur de position si échec de géolocalisation
	setMarkerIcon: function()
	{
		this.marker.setIcon( this.geolocation.isLocated() ? this.icons.valid : this.icons.error );
	},


	// Recentre la carte sur une position
	setMapLatLng: function( latlng, zoom )
	{
		this.map.setView( latlng, zoom || this.map.getZoom() );
	},


	// Déplace le marqueur sur notre position
	setMarkerLatLng: function()
	{
		this.marker.setLatLng( this.geolocation.getLatLng() );
		if( app.not('moved') )
		{
			this.map.panTo( this.geolocation.getLatLng() );
		}
	},


	// Défini le texte de positionnement
	setPositionText: function( latlng )
	{
		var lat = latlng.lat || '…';
		this.$lat.text( _.isNumber( lat ) ? lat.toFixed(6) : lat );

		var lng = latlng.lng || '…';
		this.$lng.text( _.isNumber( lng ) ? lng.toFixed(6) : lng );
	},


	// Affiche une erreur de positionnement
	setPositionError: function( error )
	{
		this.$lat.html( $('<em/>',{ class:'text-danger small' }).text( error ) );
		this.$lng.text( '' );
	},



	/**
	 * Online : API bbox → Dexie → lecture locale.
	 * Offline : Dexie seul (cache opportuniste + mine).
	 * Événements : viewport:loading / viewport:loaded.
	 */
	loadViewportPonds: _.debounce( function()
	{
		if( !this.map )
		{
			return;
		}

		var self = this;
		var bounds = this.map.getBounds().pad( 0.15 );

		var finish = function()
		{
			self.trigger( 'viewport:loaded' );
		};

		var readLocal = function()
		{
			return repo.getPondsInBounds( bounds ).then( function( rows )
			{
				self.collection.reset( rows, { silent: true } );
				self.setMarkerList();
			} );
		};

		// Hors ligne : fallback Dexie uniquement
		if( !app.is( 'online' ) )
		{
			readLocal().then( finish ).catch( function( err )
			{
				console.error( 'loadViewportPonds offline', err );
				finish();
			} );
			return;
		}

		self.trigger( 'viewport:loading' );

		var b = bounds;
		$.ajax( {
			url: config.url.pond,
			method: 'GET',
			dataType: 'json',
			data: {
				published: 1,
				north: b.getNorth(),
				south: b.getSouth(),
				east: b.getEast(),
				west: b.getWest(),
				limit: 1000,
			},
		} ).done( function( json )
		{
			var list = _.isArray( json ) ? json : ( json && json.data ? json.data : [] );
			var write = list.length ? repo.putPonds( list ) : Promise.resolve();

			write.then( readLocal ).catch( function( err )
			{
				console.error( 'loadViewportPonds write', err );
				return readLocal();
			} ).then( finish ).catch( finish );
		} ).fail( function( xhr )
		{
			console.warn( 'loadViewportPonds api', xhr && xhr.status );
			readLocal().then( finish ).catch( function( err )
			{
				console.error( 'loadViewportPonds fallback', err );
				finish();
			} );
		} );
	}, 100 ),

	setMarkerList: _.debounce( function()
	{
		var colors = _.object( [ 'n', 's', 'v', 'l' ], [ '#ffc107', '#17a2b8', '#00A248', '#dc3545' ] );
		var seen = {};
		var self = this;

		// Ajoute ou met à jour les marqueurs du viewport
		this.collection.each( function( pond )
		{
			if( !pond.has( 'lat' ) || !pond.has( 'lng' ) )
			{
				return;
			}

			var uuid = pond.get( 'uuid' );
			if( !uuid )
			{
				return;
			}

			seen[uuid] = true;
			var fill = colors[ ( pond.get( 'status' ) || 'n' ).charAt( 0 ) ] || '#ffc107';
			var existing = self.markersByUuid[uuid];

			// Déjà présent : maj légère sans recréer (évite le clignotement)
			if( existing )
			{
				existing.setLatLng( pond.getLatLng() );
				existing.setStyle( { fillColor: fill } );
				return;
			}

			var marker = L.circleMarker( pond.getLatLng(), {
				color: '#fff',
				weight: 1.5,
				fillOpacity: 0.8,
				fillColor: fill,
			} );

			marker.on( 'click', function()
			{
				app.redirect( pond.toUrl( 'pond/view' ) );
			} );

			self.markersByUuid[uuid] = marker;

			if( self.map )
			{
				self.map.addLayer( marker );
			}
		} );

		// Retire les marqueurs hors viewport
		_.each( _.keys( this.markersByUuid ), function( uuid )
		{
			if( seen[uuid] )
			{
				return;
			}

			var marker = self.markersByUuid[uuid];
			marker.off();
			marker.remove();
			delete self.markersByUuid[uuid];
		} );
	}, 100 ),

	unsetMarkerList: function()
	{
		_.each( _.keys( this.markersByUuid ), _.bind( function( uuid )
		{
			var marker = this.markersByUuid[uuid];
			marker.off();
			marker.remove();
			delete this.markersByUuid[uuid];
		}, this ) );
	},


	setMapType: function( type )
	{
		if( this.map )
		{
			this.settings.set({ type: type });

			// Changer de layer
			for( var id in this.layer )
			{
				if( id == type )
				{
					this.map.addLayer( this.layer[id] );
				}
				else
				{
					this.map.removeLayer( this.layer[id] );
				}
			}
		}

		// Modifier le menu
		this.$("#"+this.cid+"-map-type .js-map-type").each(function()
		{
			var ok = $(this).data('type') == type;
			$(this).toggleClass( 'color-green', ok ).toggleClass( 'text-secondary', !ok );
		});
	},
	getMapType: function()
	{
		if( this.map )
		{
			for( var id in this.layer )
			{
				if( this.map.hasLayer( this.layer[id] ) )
				{
					return id;
				}
			}
		}
	},

	setAccuracyAlert: _.debounce( function()
	{
		var elt = this.$("#"+this.cid+"-accuracy");
		var accuracy = this.geolocation.get('accuracy');

		if( !this.geolocation.isLocated() )
		{
			elt.text( this.geolocation.getError('Échec de la géolocalisation par GPS' ) ).removeClass('d-none');
		}
		else if( isNaN( accuracy ) )
		{
			elt.text( this.geolocation.getError('Veuillez activer la géolocalisation par GPS' ) ).removeClass('d-none');
		}
		else if( accuracy > 10 )
		{
			var u = (accuracy >= 1000) ? 'km' : 'm';
			var v = (accuracy >= 1000) ? (accuracy/1000) : accuracy;
			elt.html( "Votre localisation n'est pas précise (±"+v.toFixed()+u+")" ).removeClass('d-none');
		}
		else
		{
			elt.addClass('d-none');
		}
	}, 100 ),


	getConfig: function()
	{
		return this.settings.attributes;
	},

	setConfig: _.debounce( function()
	{
		this.settings.set({
			lat: this.map.getCenter().lat,
			lng: this.map.getCenter().lng,
			zoom: this.map.getZoom(),
			type: this.getMapType(),
		});
	}, 100 ),



	render: function( options )
	{
		this.options = _.extend({
			label: "Position :"
		}, options );


		this.setElement('#map');

		// On charge la page avec le nouvel HTML
		this.$el.html( this.template({
			cid: this.cid,
			label: this.options.label,
			status_list: config.status_list
		}));


		this.$lat = this.$("#"+this.cid+"-lat");
		this.$lng = this.$("#"+this.cid+"-lng");

		this.delegateEvents();

		// Initialisation carte
		var options = _.extend( {}, config.map, {
			renderer: L.canvas(),
			center: this.getLatLng(),
			zoom: this.settings.get('zoom'),
		});
		var map = L.map( this.cid+'-map', options );
		this.map = map;


		// Indiquer que la carte a été déplacé et donc il faudra la réafficher sur la position choisie et non plus sur ma position
		this.listenTo( this.map, 'dragstart', function( evt ) { app.set( 'moved', true ); });

		// Pan/zoom : recharger le viewport (pas "load" : déjà émis pendant L.map())
		this.listenTo( this.map, 'moveend zoomend', _.debounce( function()
		{
			this.loadViewportPonds();
			this.setConfig();
		}, 100 ) );

		// Afficher le niveau de zoom à chaque changement
		this.listenTo( this.map, 'zoomend', function()
		{
			console.log( 'zoom', this.map.getZoom() );
		});

		// Transfert de l'évènement "click"
		this.listenTo( this.map, 'click', function( evt ) { this.trigger( 'click', evt.latlng ); });

		// marqueur de notre position
		this.marker.addTo( map );

		this.setMapType( this.settings.get('type') );
		this.setAccuracyAlert();

		// Premier chargement explicite (l'événement load a déjà eu lieu dans L.map)
		this.loadViewportPonds();
		this.setConfig();

		// Et on averti du rendu au niveau de l'élément et de la vue
		this.$el.trigger('render');
		this.trigger('render');
	}
});
